import biomedicalImagingRouterPaths from './biomedicalImagingRouterPaths';

export default biomedicalImagingRouterPaths;
